import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import { isVue3, reactive } from 'vue-demi';
import { firstUpperCase } from '../_util';
export const isEventKey = key => /^on[A-Z]/.test(key);
export const getEventKey = key => key.charAt(2).toLocaleLowerCase() + key.slice(3);

// 透传事件
/**
 * @param events {key:function(){}}
 */
export function passListeners(events) {
  if (isVue3) {
    // 变成onXXX的对象再返回
    const res = {};
    _Object$entries(events).forEach(_ref => {
      let [key, val] = _ref;
      res["on".concat(firstUpperCase(key))] = val;
    });
    return res;
  }
  return {
    on: events
  };
}

// 返回 vue2 $listeners。如果事件在 emits 中定义了的话，监听事件不会出现在 $attrs 中。
export function useListeners(vm) {
  if (isVue3) {
    const keys = Object.keys(vm.$attrs).filter(key => {
      return isEventKey(key);
    });
    const listeners = reactive({});
    keys.forEach(key => {
      const newKey = getEventKey(key);
      listeners[newKey] = vm.$attrs[key];
    });
    return listeners;
  }
  return vm.$listeners;
}